// Shared style for the secondary "skip / guestbook" links that sit under the
// primary call-to-action on the Welcome and RSVP screens, plus the buttons on
// the post-RSVP success screen — so they all read as one family. Tinted purple
// pills; uses Tailwind `dark:` variants (the app keeps a `dark` class on
// <html>) so no isDarkMode prop is needed.

export const SECONDARY_LINK_CLASS =
  'px-5 py-2.5 rounded-full text-sm font-bold transition-colors ' +
  'bg-purple-50 text-purple-600 hover:bg-purple-100 ' +
  'dark:bg-purple-500/10 dark:text-purple-200 dark:hover:bg-purple-500/20';

// Row that lays the links out side by side.
export const SECONDARY_LINK_ROW = 'flex flex-wrap items-center justify-center gap-3';
